import React, { useEffect, useRef } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import Typography from '@material-ui/core/Typography';
import {
  Button,
  Card,
  CardContent,
  CardMedia,
  Checkbox,
  FormControlLabel,
  FormLabel,
  Link,
  MenuItem,
  Modal,
  Radio,
  RadioGroup,
  TableBody,
  TableCell,
  TableRow,
  TextField
} from '@material-ui/core';
import {
  AddCircleOutline,
  KeyboardArrowDown,
  KeyboardArrowUp,
  RemoveCircleOutline
} from '@material-ui/icons';
import HelpIcon from '@material-ui/icons/HelpOutlined';
import CloseIcon from '@material-ui/icons/Close';
import moment from 'moment';
import classNames from 'classnames';
import ReactSelectMaterialUi from 'react-select-material-ui';
import { isNaN } from 'lodash';
import { resizeImage, sendLogin, uploadFile } from '../../auth/Auth';
import {
  getGochiMenus,
  addGochiMenu,
  addGochiMenuImage,
  ADD_GOCHI_MENU_SUCCESS
} from '../../actions/GochiMenus';
// import { getShops } from '../../actions/Shop';
import { getOptionGroups, getOptionShops } from '../../actions/Options';
import { languages, languageType } from '../../constants/Language';
import usageTypes from '../../constants/UsageType';
import listMenuChildTypes from '../../constants/MenuChildType';
import RequiredButton from '../../components/atoms/RequiredButton';
import ValidationText from '../../components/atoms/ValidationText';
import FileUpload from '../../components/molecules/FileUpload';
import AnyButton from '../../components/atoms/AnyButton';
import CancelButton from '../../components/atoms/CancelButton';
import ConfirmButton from '../../components/atoms/ConfirmButton';
import MenuImageSampleGroupDialog from './MenuImageSampleGroupDialog';
import GochiMenuAddConfirmGroupV2 from './GochiMenuAddConfirmGroupV2';

const styles = theme => ({
  root: {
    position: 'absolute',
    width: '100%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 30,
    overflow: 'scroll',
    outline: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '95%',
      padding: 16
    }
  },
  pageTitle: {
    margin: '34px 0px 48px',
    paddingLeft: 20,
    textAlign: 'left',
    backgroundColor: '#fff',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      marginBottom: 10
    }
  },
  editTable: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      display: 'block'
    },
    '& tr': {
      [theme.breakpoints.down('sm')]: {
        display: 'block'
      }
    }
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  textField: {
    // padding: '0px 5px 0px 5px',
    minWidth: '300px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  textFieldLong: {
    // padding: '0px 5px 0px 5px',
    minWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  button: {
    margin: '5px auto'
  },
  priceCalc: {
    margin: '0px 5px',
    color: '#aaa'
  },
  colLeft: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingBottom: 5
    },
    verticalAlign: 'top',
    width: 75
  },
  colRight: {
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    },
    verticalAlign: 'top'
  },
  displayFlex: {
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      display: 'block',
      border: 0,
      paddingTop: 0
    }
  },
  displayFlexHelp: {
    display: 'flex',
    alignItems: 'end'
  },
  displayBlock: {
    display: 'block'
  },
  textMutiple: {
    paddingTop: '46px',
    width: '33px'
  },
  textFieldPriceCombo: {
    padding: '0px 5px 0px 5px',
    width: '200px',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  },
  modal: {
    maxWidth: 1153,
    margin: 'auto',
    padding: '5% 12px 5%'
  },
  title: {
    fontWeight: 700,
    fontSize: 24
  },
  buttonsContainer: {
    margin: '16px 15px 34px'
  },
  description: {
    fontWeight: 500,
    fontSize: 12
  },
  marginTop: {
    marginTop: 15
  },
  divHelp: {
    marginRight: 'auto'
  },
  divExplanation: {
    position: 'absolute',
    width: 280,
    top: 53,
    right: 21,
    zIndex: 10
  },
  textHelpExplainDiv: {
    padding: '10px 10px 0 10px'
  },
  textHelpExplain: {
    fontSize: 10
  },
  helpCloseBtn: {
    fontSize: 18,
    position: 'absolute',
    top: 3,
    right: 4,
    cursor: 'pointer'
  },
  helpCloseBtnWhite: {
    color: '#fff !important'
  },
  iconHelpEx: {
    color: 'gray !important',
    cursor: 'pointer'
  },
  positionRelative: {
    position: 'relative'
  },
  qaBox: {
    margin: '32px 0',
    padding: '0 16px'
  },
  headerNoteDonation: {
    fontSize: 16,
    fontWeight: 700,
    color: `${theme.palette.primary.main}`
  },
  answerNoteDonation: {
    display: 'flex',
    marginTop: 8
  },
  questionTextDonation: {
    fontSize: 18,
    fontWeight: 400
  },
  answerTextDonation: {
    fontSize: 16,
    fontWeight: 400,
    wordBreak: 'break-all'
  },
  handText: {
    fontSize: 20,
    fontWeight: 700,
    paddingLeft: 16
  },
  advancedSettingNote: {
    padding: '32px 16px'
  },
  paddingBottomNone: {
    paddingBottom: 0
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      // account: state.accounts.account,
      name: state.loginInfo.name,
      detail: state.gochiMenus.detail,
      groups: state.options.listGroups,
      taxTypes: state.gochiMenus.taxTypes,
      reducedTaxMenuPrefix: state.commons.reducedTaxMenuPrefix,
      account: state.accounts.account,
      languages
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getGochiMenus,
          addGochiMenu,
          addGochiMenuImage,
          getOptionGroups,
          getOptionShops
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openAddConfirm', 'updateOpenAddConfirm', false),
  withState('isLanguage', 'setIsLanguage', 'ja'),
  withState('translateType', 'setTranslateType', 0),
  withState('multiLangData', 'setMultiLangData', {}),
  withState('menuName', 'setMenuName', ''),
  withState('menuNameError', 'setMenuNameError', ''),
  withState('image', 'setImage', null),
  withState('previewImage', 'setPreviewImage', null),
  withState('imageError', 'setImageError', ''),
  withState('isImageDefault', 'setIsImageDefault', false),
  withState('price', 'setPrice', ''),
  withState('priceError', 'setPriceError', ''),
  withState('priceCalc', 'setPriceCalc', '000 (税込み)'),
  withState('taxType', 'setTaxType', 'INTERNAL'),
  withState('reducedTaxCheck', 'setReducedTaxCheck', false),
  withState('reducedTaxType', 'setReducedTaxType', 'UNREDUCED'),
  withState('menuGenreId', 'setMenuGenreId', null),
  withState('menuGenreError', 'setMenuGenreError', ''),
  withState('description', 'setDescription', ''),
  withState('tagStr', 'setTagStr', ''),
  withState('tags', 'setTags', null),
  withState('openAdvancedSetting', 'updateOpenAdvancedSetting', false),
  withState('expiration', 'setExpiration', ''),
  withState('expirationError', 'setExpirationError', ''),
  withState('expirationType', 'setExpirationType', 2),
  withState('expirationEndDate', 'setExpirationEndDate', ''),
  withState('menuLimitTotal', 'setMenuLimitTotal', 1),
  withState('minExpirationDate', 'setMinExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('maxExpirationDate', 'setMaxExpirationDate', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .add(180, 'days')
      .format('YYYY-MM-DD');
  }),
  withState('expirationList', 'setExpirationList', () => {
    const tmpList = [];
    for (let i = 1; i <= 180; i += 1) {
      tmpList.push({
        label: `${i}日間`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('helpExpiration', 'setHelpExpiration', false),
  withState('helpDonation', 'setHelpDonation', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    }
  }),
  withState(
    'openMenuImageSamplePopup',
    'updateOpenMenuImageSamplePopup',
    false
  ),
  withState('showQADonation', 'setShowQADonation', false),
  withState('comboMenu', 'setComboMenu', 0),
  withState('priceCombo', 'setPriceCombo', ''),
  withState('priceComboError', 'setPriceComboError', ''),
  withState('quantityRelease', 'setQuantityRelease', ''),
  withState('quantityReleaseError', 'setQuantityReleaseError', ''),
  withState('quantityPromotion', 'setQuantityPromotion', ''),
  withState('quantityPromotionError', 'setQuantityPromotionError', ''),
  withState('promotionDescription', 'setPromotionDescription', ''),
  withState('quantityReleaseList', 'setQuantityReleaseList', () => {
    const tmpList = [];
    for (let i = 0; i <= 100; i += 1) {
      tmpList.push({
        label: `${i}`,
        value: String(i)
      });
    }
    return tmpList;
  }),
  withState('helpPriceCombo', 'setHelpPriceCombo', false),
  withState('menuGenreName', 'setMenuGenreName', ''),
  withState('usageLimit', 'setUsageLimit', 0),
  withState('subscriptionInterval', 'setSubscriptionInterval', 'WEEK'),
  withState('subscriptionIntervalCount', 'setSubscriptionIntervalCount', ''),
  withState('subscripIntervalCountError', 'setSubscripIntervalCountError', ''),
  withState('subscription', 'setSubscription', 0),
  withState('menuSituationIds', 'setmenuSituationIds', []),
  withState('menuUserTargetIds', 'setmenuUserTargetIds', []),
  lifecycle({
    componentDidMount() {
      let dataFirst = {};
      const origilData = {
        shopId: null,
        menuChildType: null,
        menuCombo: null,
        menuLimitTotal: null,
        groupId: null,
        menuName: null,
        price: null,
        priceCombo: null,
        quantity: null,
        quantityFree: null,
        quantityFreeDes: null,
        numberUsePerDay: null,
        expirationType: null,
        expiration: null,
        expirationEndDate: null,
        description: null,
        taxType: null,
        reducedTaxType: null,
        tagStr: null,
        tags: null,
        menuGenreId: null,
        subscription: null,
        subscriptionIntervalCount: null,
        subscriptionInterval: null,
        menuSituationIds: [],
        menuUserTargetIds: []
      };
      const arr = [];
      languages.forEach(item => {
        if (item.value === languageType.ORIGIN) {
          dataFirst = origilData;
        } else {
          const other = {
            translateType: 0,
            language: item.value
          };
          arr.push(other);
        }
      });
      dataFirst.otherLanguages = arr;
      this.props.setMultiLangData(dataFirst);

      if (this.props.usageType === usageTypes[1].id) {
        this.props.setTagStr(`#${usageTypes[1].name}`);
        this.props.setTags([{ tagName: `#${usageTypes[1].name}` }]);
        this.props.setMenuLimitTotal(1);
      } else if (this.props.usageType === usageTypes[2].id) {
        this.props.setTagStr(`#${usageTypes[2].name}`);
        this.props.setTags([{ tagName: `#${usageTypes[2].name}` }]);
        this.props.setMenuName('GOCHI 回数券');
        this.props.setComboMenu(1);
        this.props.setDescription(
          `${this.props.shopName ||
            this.props.groups[0]
              .groupName}のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
        );
      }
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    processBox,
    openAddConfirm,
    account,
    checkSession,
    updateOpenAddConfirm,
    shops,
    shopId,
    shopName,
    updateOpenAdd,
    usageType,
    menuChildType,
    menuName,
    setMenuName,
    menuNameError,
    setMenuNameError,
    image,
    setImage,
    previewImage,
    setPreviewImage,
    isImageDefault,
    setIsImageDefault,
    imageError,
    setImageError,
    price,
    setPrice,
    priceError,
    setPriceError,
    priceCalc,
    setPriceCalc,
    taxType,
    setTaxType,
    taxTypes,
    reducedTaxCheck,
    setReducedTaxCheck,
    reducedTaxType,
    setReducedTaxType,
    menuGenreId,
    setMenuGenreId,
    menuGenre,
    menuGenreError,
    setMenuGenreError,
    description,
    setDescription,
    tagStr,
    setTagStr,
    tags,
    setTags,
    groups,
    openAdvancedSetting,
    updateOpenAdvancedSetting,
    setExpirationType,
    setExpirationEndDate,
    expirationList,
    expirationType,
    minExpirationDate,
    maxExpirationDate,
    expiration,
    setExpiration,
    expirationError,
    setExpirationError,
    expirationEndDate,
    helpExpiration,
    setHelpExpiration,
    helpDonation,
    setHelpDonation,
    openMenuImageSamplePopup,
    updateOpenMenuImageSamplePopup,
    menuImageSampleList,
    menuLimitTotal,
    setMenuLimitTotal,
    showQADonation,
    setShowQADonation,
    comboMenu,
    priceCombo,
    setPriceCombo,
    priceComboError,
    setPriceComboError,
    quantityRelease,
    setQuantityRelease,
    quantityReleaseError,
    setQuantityReleaseError,
    quantityPromotion,
    setQuantityPromotion,
    quantityPromotionError,
    setQuantityPromotionError,
    quantityReleaseList,
    promotionDescription,
    setPromotionDescription,
    helpPriceCombo,
    setHelpPriceCombo,
    shopGochiRestriction,
    menuGenreName,
    setMenuGenreName,
    isLanguage,
    multiLangData,
    setMultiLangData,
    translateType,
    usageLimit,
    setUsageLimit,
    reducedTaxMenuPrefix,
    subscriptionInterval,
    subscriptionIntervalCount,
    subscription,
    subscripIntervalCountError,
    setSubscripIntervalCountError,
    menuSituationIds,
    menuUserTargetIds
  }) => {
    const USAGE_TYPE_MENU = usageTypes[0].id;
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;
    const USAGE_TYPE_COMBO = usageTypes[2].id;
    const IMAGE_DEFAULT_VOUCHER = '/images/background_voucher.png';
    const IMAGE_DEFAULT_COMBO = '/images/background_combo.png';

    const errors = {
      menuNameError,
      imageError,
      priceError,
      menuGenreError,
      expirationError,
      priceComboError,
      quantityReleaseError,
      quantityPromotionError,
      subscripIntervalCountError
    };

    const addWaterMark = async inputPrice => {
      const canvas = await new Promise(resolve => {
        let objectURL = '';
        if (usageType === USAGE_TYPE_VOUCHER) {
          objectURL = IMAGE_DEFAULT_VOUCHER;
        } else if (usageType === USAGE_TYPE_COMBO) {
          objectURL = IMAGE_DEFAULT_COMBO;
        }
        const c = document.createElement('canvas');
        const ctx = c.getContext('2d');
        const img = new Image();

        img.onload = () => {
          ctx.canvas.width = img.width;
          ctx.canvas.height = img.height;
          ctx.drawImage(img, 0, 0, img.width, img.height);
          ctx.fillStyle = 'black';
          ctx.font =
            "700 100px 'Yu Gothic', 'Roboto', 'Helvetica', 'Arial', sans-serif";
          const tempPrice = parseInt(inputPrice, 10);
          const textString = isNaN(tempPrice)
            ? ''
            : `${tempPrice.toLocaleString()}${
                usageType === USAGE_TYPE_VOUCHER ? '円' : '円分'
              }`;
          const textWidth = ctx.measureText(textString).width;
          ctx.fillText(
            textString,
            ctx.canvas.width / 2 - textWidth / 2,
            ctx.canvas.height / 2
          );
          resolve(c);
        };
        img.src = objectURL;
        console.log('objectURL', objectURL);
      });

      return new Promise(resolve => {
        canvas.toBlob(
          newblob => {
            resolve(newblob);
          },
          'image/png',
          1
        );
      });
    };

    const renderImageDefault = async (inputPrice, isClick) => {
      // handle asynchronous when render image from price
      window.priceRenderImageMenu = inputPrice;
      let fileName = '';
      if (!isImageDefault && previewImage && !isClick) {
        return;
      }
      if (usageType === USAGE_TYPE_VOUCHER) {
        fileName = `${shopName || groups[0].groupName}の${inputPrice}円商品券`;
      } else if (usageType === USAGE_TYPE_COMBO) {
        fileName = `${shopName || groups[0].groupName}の${inputPrice}円回数券`;
      }
      const newBlob = await addWaterMark(inputPrice);
      const blob = new Blob([newBlob], { type: 'image/png' });
      const newImage = new File([blob], `${fileName}.png`, {
        type: blob.type
      });
      const reader = new FileReader();
      reader.readAsDataURL(newImage);
      setImage(newImage);
      setIsImageDefault(true);
      setImageError('');
      reader.onloadend = () => {
        if (inputPrice === window.priceRenderImageMenu) {
          setPreviewImage(reader.result);
        }
      };
    };

    const autoRenderDescription = () => {
      if (usageType === USAGE_TYPE_COMBO) {
        if (
          quantityPromotion &&
          quantityPromotion !== '0' &&
          promotionDescription
        ) {
          setDescription(
            `${shopName ||
              groups[0]
                .groupName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (quantityPromotion && quantityPromotion !== '0') {
          setDescription(
            `${shopName ||
              groups[0]
                .groupName}のつかえる回数券です。無料で${quantityPromotion}枚が追加されます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else if (promotionDescription) {
          setDescription(
            `${shopName ||
              groups[0]
                .groupName}のつかえる回数券です。${promotionDescription}がつきます。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        } else {
          setDescription(
            `${shopName ||
              groups[0]
                .groupName}のつかえる回数券です。プレゼントにも、ご自身のためにもお使いいただけます。`
          );
        }
      }
    };

    useEffect(() => {
      autoRenderDescription();
    }, [quantityPromotion, promotionDescription]);

    const getUsageTypeName = usageTypeId => {
      if (usageTypeId) {
        const usageTypeName = usageTypes.find(
          usage => usage.id.toString() === usageTypeId.toString()
        ).name;
        return usageTypeName;
      }
      return '';
    };

    const getMenuChildTypeName = menuChildTypeId => {
      if (menuChildTypeId) {
        let menuChildTypeName = listMenuChildTypes.find(
          childType => childType.id.toString() === menuChildTypeId.toString()
        ).name;
        if (menuChildTypeId === 1) {
          menuChildTypeName = '店舗指定';
        } else if (menuChildTypeId === 4) {
          menuChildTypeName = 'グループ全体';
        }
        return menuChildTypeName;
      }
      return '';
    };

    const getGenreName = () => {
      if (menuGenreId) {
        const genreName = menuGenre.find(
          genre => genre.menuGenreId.toString() === menuGenreId.toString()
        ).menuGenreName;
        return genreName;
      }
      return '';
    };

    const handleAddImage = imageInput => {
      setPreviewImage(imageInput);
      setIsImageDefault(false);
      setImageError('');
    };

    const calcPrice = e => {
      let includedTaxPrice = 0;
      let excludedTaxPrice = 0;

      let latestPrice = price;
      if (e.target.id === 'price') {
        latestPrice = e.target.value;
      }

      let latestTaxType = taxType;
      if (e.target.name === 'taxType') {
        latestTaxType = e.target.value;
      }

      if (e.target.id === 'isDonation') {
        if (e.target.checked) {
          latestTaxType = 'DONATION';
        } else {
          latestTaxType = 'INTERNAL';
        }
      }

      let lastestPriceCombo = priceCombo;
      if (e.target.id === 'priceCombo') {
        lastestPriceCombo = e.target.value;
      }

      let lastestQuantityRelease = quantityRelease;
      if (e.target.name === 'quantityRelease') {
        lastestQuantityRelease = e.target.value;
      }

      if (
        lastestPriceCombo &&
        lastestPriceCombo !== '' &&
        lastestQuantityRelease &&
        lastestQuantityRelease !== ''
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }
      if (
        (!lastestPriceCombo ||
          lastestPriceCombo === '' ||
          !lastestQuantityRelease ||
          lastestQuantityRelease === '') &&
        comboMenu === 1
      ) {
        setPrice(lastestPriceCombo * lastestQuantityRelease);
        renderImageDefault(lastestPriceCombo * lastestQuantityRelease, false);
        setPriceCalc('000 (税込み)');
        latestPrice = lastestPriceCombo * lastestQuantityRelease;
      }

      // TODO DBから取得
      let tax = 0.1;
      if (
        (e.target.id !== 'reducedTax' && reducedTaxCheck) ||
        (e.target.id === 'reducedTax' && e.target.checked)
      ) {
        // TODO DBから取得
        tax = 0.08;
      }

      if (latestPrice !== '') {
        if (latestTaxType === 'INTERNAL') {
          const amountTemp = parseFloat((latestPrice / (1 + tax)).toFixed(9));
          const taxAmount = Math.round(amountTemp * tax);
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice - taxAmount;
        } else if (latestTaxType === 'DONATION') {
          includedTaxPrice = latestPrice;
          excludedTaxPrice = latestPrice;
        } else {
          const taxAmount = Math.round(latestPrice * tax);
          includedTaxPrice = latestPrice * 1 + taxAmount;
          excludedTaxPrice = latestPrice;
        }
      }
      console.log(excludedTaxPrice);
      // setPriceCalc(`${includedTaxPrice} (税抜 ${excludedTaxPrice})`);
      const val =
        e.target.id !== 'reducedTax' &&
        typeof e.target.id !== 'undefined' &&
        e.target.id !== 'isDonation'
          ? e.target.value
          : includedTaxPrice;
      console.log('val', val);
      const priceShow =
        val !== '' ? parseInt(includedTaxPrice, 0).toString() : '000';
      setPriceCalc(`${priceShow} (税込み)`);
    };

    const convertReducedTax = checked => {
      if (checked) {
        setReducedTaxType('REDUCED');
      } else {
        setReducedTaxType('UNREDUCED');
      }
    };

    const splitTagStr = str => {
      if (str === '') {
        setTags(null);
      } else {
        setTags(
          str.split(/\s+/).map(t => {
            return { tagName: t };
          })
        );
      }
    };

    const getShopOptions = () => {
      const shopOptions = [];
      const tmpObj = { label: '', value: '0', restriction: '' };
      shops.forEach(shop => {
        shopOptions.push({
          label: shop.shopName,
          value: String(shop.shopId)
        });
      });
      return shopOptions.length > 0 ? { ...shopOptions, tmpObj } : shopOptions;
    };

    const resetExpirationValue = () => {
      setExpiration('');
      setExpirationEndDate('');
    };

    const handleShowHelpExpiration = () => {
      setHelpExpiration(true);
    };

    const handleShowHelpPriceCombo = () => {
      setHelpPriceCombo(true);
    };

    const handleShowHelpDonation = () => {
      setHelpDonation(true);
    };

    const handleCloseHelpPopup = () => {
      setHelpPriceCombo(false);
      setHelpExpiration(false);
      setHelpDonation(false);
    };

    const ref = useRef();

    const handleClose = e => {
      if (helpPriceCombo) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpPriceCombo(false);
        }
      }
      if (helpExpiration) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpExpiration(false);
        }
      }
      if (helpDonation) {
        if (ref.current && !ref.current.contains(e.target)) {
          setHelpDonation(false);
        }
      }
    };

    useEffect(() => {
      document.addEventListener('click', handleClose);
      return () => {
        document.removeEventListener('click', handleClose);
      };
    });

    const validMenuName = () => {
      const value = menuName;
      if (value.trim() === '') {
        setMenuNameError('必須項目です。');
        return 1;
      }
      setMenuNameError('');
      setMenuName(value);
      return 0;
    };

    const validPrice = () => {
      const value = price;
      if (value === '') {
        setPriceError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceError('半角数字のみ入力してください。');
        return 1;
      }
      if (parseInt(value, 10) > 999999999) {
        setPriceError('999,999,999円以下ご入力ください。');
        return 1;
      }
      setPriceError('');
      setPrice(value);
      return 0;
    };

    const validMenuGenre = () => {
      const value = menuGenreId;
      if (!value) {
        setMenuGenreError('必須項目です。');
        return 1;
      }
      setMenuGenreError('');
      setMenuGenreId(value);
      return 0;
    };

    const validExpiration = () => {
      const value = expiration;
      if (value === '') {
        setExpirationError('');
        return 0;
      }
      if (!/\b([1-9]|[1-9][0-9]|1[0-7][0-9]|180)\b/.test(value)) {
        setExpirationError('半角数字のみ入力してください。From 1 - 180');
        return 1;
      }
      setExpirationError('');
      setExpiration(parseInt(value, 10));
      return 0;
    };

    const validPriceCombo = () => {
      const value = priceCombo;
      if (value === '') {
        setPriceComboError('必須項目です。');
        return 1;
      }
      if (!/^\d+$/.test(value)) {
        setPriceComboError('半角数字のみ入力してください。');
        return 1;
      }
      setPriceComboError('');
      setPriceCombo(parseInt(value, 10));
      return 0;
    };

    const validQuantityRelease = () => {
      const value = quantityRelease;
      if (value === '') {
        setQuantityReleaseError('必須項目です。');
        return 1;
      }
      if (!/^[1-9]|[1-9]\d+$/.test(value)) {
        setQuantityReleaseError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityReleaseError('');
      setQuantityRelease(parseInt(value, 10));
      return 0;
    };

    const validQuantityPromotion = () => {
      const value = quantityPromotion;
      if (value === '') {
        setQuantityPromotionError('');
        return 0;
      }
      if (!/^\d+$/.test(value)) {
        setQuantityPromotionError('半角数字のみ入力してください。');
        return 1;
      }
      setQuantityPromotionError('');
      setQuantityPromotion(parseInt(value, 10));
      return 0;
    };

    const validImageMenu = () => {
      const value = previewImage;
      if (!value) {
        setImageError('必須項目です。');
        return 1;
      }
      setImageError('');
      return 0;
    };

    const validSubscriptionIntervalCount = () => {
      const checkSubscription = subscription;
      if (checkSubscription === 1) {
        const valueIntervalCount = subscriptionIntervalCount;
        const valueInterval = subscriptionInterval;
        if (valueIntervalCount === '') {
          setSubscripIntervalCountError('必須項目です。');
          return 1;
        }
        if (Number(valueIntervalCount) < 1) {
          setSubscripIntervalCountError('頻度価値は1以上ご入力ください');
          return 1;
        }
        if (!/^\d+$/.test(valueIntervalCount)) {
          setSubscripIntervalCountError('半角数字のみ入力してください。');
          return 1;
        }
        if (valueInterval === 'WEEK' && Number(valueIntervalCount) > 52) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
        if (valueInterval === 'MONTH' && Number(valueIntervalCount) > 12) {
          setSubscripIntervalCountError(
            '頻度価値は週間サブスクに対して52以下、月間サブスクに対して12以下入力してください。'
          );
          return 1;
        }
      }
      setSubscripIntervalCountError('');
      return 0;
    };

    const valid = () => {
      let errorCount = 0;
      const validMenuNameCount = validMenuName();
      const validImageMenuCount =
        usageType === USAGE_TYPE_MENU ? 0 : validImageMenu();

      if (usageType !== USAGE_TYPE_COMBO) {
        errorCount =
          validMenuNameCount +
          validPrice() +
          validExpiration() +
          validMenuGenre() +
          validImageMenuCount +
          validSubscriptionIntervalCount();
      } else if (comboMenu === 1) {
        errorCount =
          validMenuNameCount +
          validPriceCombo() +
          validQuantityRelease() +
          validQuantityPromotion() +
          validExpiration() +
          validMenuGenre() +
          validImageMenuCount +
          validSubscriptionIntervalCount();
      }

      if (
        (validMenuNameCount > 0 || validImageMenuCount > 0) &&
        usageType !== USAGE_TYPE_MENU
      ) {
        updateOpenAdvancedSetting(true);
      }

      if (errorCount === 0) {
        return true;
      }
      return false;
    };

    const cancelAction = () => updateOpenAdd(false);

    const getCurrentData = () => {
      const lang = isLanguage;
      let data = multiLangData;
      const origilParam = {
        menuChildType,
        shopId,
        menuName,
        price,
        description,
        menuCombo: comboMenu,
        menuLimitTotal:
          usageType === USAGE_TYPE_VOUCHER ? menuLimitTotal : undefined,
        priceCombo,
        quantity: quantityRelease,
        quantityFree: quantityPromotion,
        quantityFreeDes: promotionDescription,
        numberUsePerDay: usageLimit,
        expirationType,
        expiration,
        expirationEndDate,
        taxType,
        reducedTaxType,
        tags,
        tagStr,
        menuGenreId,
        usageType,
        subscription,
        subscriptionIntervalCount:
          subscription === 1 ? subscriptionIntervalCount : undefined,
        subscriptionInterval:
          subscription === 1 ? subscriptionInterval : undefined,
        menuSituationIds,
        menuUserTargetIds
      };
      const otherParam = {
        translateType,
        language: lang,
        params: {
          menuName,
          description,
          quantityFreeDes: promotionDescription
        }
      };
      // origin
      if (lang === languageType.ORIGIN) {
        data = { ...data, ...origilParam };
      } else {
        // other languages
        for (let index = 0; index < data.otherLanguages.length; index += 1) {
          if (data.otherLanguages[index].language === lang) {
            data.otherLanguages[index] = otherParam;
          }
        }
      }
      const str = JSON.stringify(data);
      return JSON.parse(str);
    };

    const confirmAction = () => {
      if (!valid()) {
        alert('登録情報を正しく入力してください。');
      } else {
        setMenuGenreName(getGenreName());
        setMultiLangData(getCurrentData());
        updateOpenAddConfirm(true);
      }
    };

    const backAction = () => updateOpenAddConfirm(false);

    const registerAction = async () => {
      processBox.setLoading(true);
      processBox.updateOpenProgress(true);
      let params = {};
      if (account.fukuokaFlag) {
        params = {
          ...multiLangData,
          shashokuOn: 1,
          gochimeshiOn: 0
        };
      } else {
        params = {
          ...multiLangData,
          shashokuOn:
            !multiLangData.menuCombo && !multiLangData.menuLimitTotal ? 1 : 0
        };
      }
      const addedMenu = await actions
        .addGochiMenu(params)
        .then(data => checkSession(data));
      if (addedMenu.type === ADD_GOCHI_MENU_SUCCESS) {
        if (image !== null) {
          let imageData = image;
          if (imageData.size > Number(process.env.REACT_APP_RESIZE_BORDER)) {
            const { resizeImageFile } = await resizeImage(imageData);
            imageData = resizeImageFile;
          }
          const imagePath = await uploadFile(
            'menu',
            addedMenu.payload.menuId,
            imageData,
            'public'
          );
          await actions
            .addGochiMenuImage(addedMenu.payload.menuId, {
              image: imagePath
            })
            .then(data => checkSession(data));
        }
        processBox.setMessage('登録が完了しました。');
      } else {
        processBox.setErrorMessage('登録に失敗しました。');
        processBox.updateOpenProgress(false);
      }
      processBox.setLoading(false);
    };

    return (
      <>
        <div className={classes.root}>
          <div className={classes.pageTitle}>
            <Typography className={classes.title}>
              メニュー追加（2/2）
            </Typography>
          </div>

          <div>
            <Typography
              className={classes.handText}
              style={{ paddingBottom: 16 }}
            >
              {`用途: ${getUsageTypeName(usageType)}`}
            </Typography>
            <Typography
              className={classes.handText}
              style={{ paddingBottom: 32 }}
            >
              {`対象: ${getMenuChildTypeName(menuChildType)} `}
            </Typography>
          </div>

          <Table className={classes.editTable}>
            <TableBody>
              {menuChildType !== 4 && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <ReactSelectMaterialUi
                      required
                      label="店舗名*"
                      className={[classes.textField, classes.textFieldLong]}
                      value={String(shopId)}
                      options={getShopOptions()}
                      disabled
                    />
                  </TableCell>
                </TableRow>
              )}
              {usageType === USAGE_TYPE_MENU && (
                <>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        required
                        label="メニュー名"
                        defaultValue={menuName}
                        className={classes.textField}
                        onChange={e => {
                          setMenuName(e.target.value);
                        }}
                        onBlur={validMenuName}
                        fullWidth
                        InputLabelProps={{
                          shrink: true
                        }}
                        value={menuName}
                        inputProps={{
                          maxLength: 250
                        }}
                      />
                      <ValidationText message={errors.menuNameError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <FormLabel className={classes.description}>
                        メニュー画像
                      </FormLabel>
                      {/* <div>
                        <Button
                          variant="outlined"
                          color="primary"
                          component="span"
                          className={classes.button}
                          onClick={() => updateOpenMenuImageSamplePopup(true)}
                        >
                          デフォルト画像を選択
                        </Button>
                      </div> */}
                      <FileUpload
                        label="image"
                        file={image}
                        setFile={setImage}
                        previewImage={previewImage}
                        setPreviewImage={handleAddImage}
                        isOnlyImage
                      />
                      <div className={classes.textExplain}>
                        ※8MB以内でお願いします。
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              )}
              {usageType === USAGE_TYPE_COMBO ? (
                <>
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colLeft,
                        classes.paddingBottomNone
                      ]}
                    >
                      <RequiredButton />
                    </TableCell>
                    <TableCell
                      className={classNames(
                        classes.tableCellBorderNone,
                        classes.colRight,
                        classes.positionRelative,
                        classes.paddingBottomNone
                      )}
                    >
                      <div className={classes.displayFlexHelp}>
                        <div className={classes.divHelp}>
                          <Typography className={classes.description}>
                            単価×発行枚数
                          </Typography>
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpPriceCombo}
                        />
                        {helpPriceCombo && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CardMedia
                                component="img"
                                width="280"
                                className={classes.media}
                                image="images/help_comboPrice.png"
                                title="Menu price explaination"
                              />
                              <CloseIcon
                                className={[
                                  classes.helpCloseBtn,
                                  classes.helpCloseBtnWhite
                                ]}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography
                                  variant="body2"
                                  component="p"
                                  className={classes.textHelpExplain}
                                >
                                  メニュー名の後に表示される回数券の「単価」と「発行枚数」です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    />
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <div className={classes.displayFlex}>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="priceCombo"
                            required
                            label="単価"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={priceCombo}
                            onChange={e => {
                              setPriceCombo(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validPriceCombo}
                          />
                          <ValidationText message={errors.priceComboError} />
                        </div>
                        {/* <div className={classes.priceCalc}>{priceCalc}</div> */}
                        <div className={classes.textMutiple}>円 x</div>
                        <div className={classes.displayBlock}>
                          <TextField
                            id="quantityRelease"
                            name="quantityRelease"
                            select
                            required
                            label="発行枚数"
                            className={classes.textFieldPriceCombo}
                            margin="normal"
                            value={quantityRelease}
                            InputProps={{
                              shrink: true
                            }}
                            onChange={e => {
                              setQuantityRelease(e.target.value.trim());
                              calcPrice(e);
                            }}
                            onBlur={validQuantityRelease}
                          >
                            {quantityReleaseList.map(item => {
                              return (
                                <MenuItem key={item.value} value={item.value}>
                                  {item.label}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          <ValidationText
                            message={errors.quantityReleaseError}
                          />
                        </div>
                        <div className={classes.textMutiple}>枚</div>
                      </div>
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <RequiredButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      id="price"
                      disabled={usageType === USAGE_TYPE_COMBO}
                      required
                      label="価格"
                      defaultValue={price}
                      className={classes.textField}
                      value={price}
                      onChange={e => {
                        const tempPrice = e.target.value.trim();
                        setPrice(tempPrice);
                        calcPrice(e);
                        if (usageType === USAGE_TYPE_VOUCHER) {
                          const priceText = isNaN(parseInt(tempPrice, 10))
                            ? ''
                            : parseInt(tempPrice, 10).toLocaleString();
                          renderImageDefault(tempPrice, false);
                          setMenuName(`GOCHI ${priceText}円券`);
                          setMenuNameError('');
                          setDescription(
                            `${shopName ||
                              groups[0]
                                .groupName}の${priceText}円分使える商品券です。プレゼントにどうぞ。`
                          );
                        }
                      }}
                      onBlur={validPrice}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                    />
                    <ValidationText message={errors.priceError} />
                    <div className={classes.priceCalc}>{priceCalc}</div>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <div>
                    <TextField
                      id="taxType"
                      name="taxType"
                      select
                      label="税区分"
                      disabled={
                        taxType === 'DONATION' || usageType !== USAGE_TYPE_MENU
                      }
                      className={classes.textField}
                      value={taxType === 'DONATION' ? 'INTERNAL' : taxType}
                      onChange={e => {
                        setTaxType(e.target.value.trim());
                        calcPrice(e);
                      }}
                      InputLabelProps={{
                        shrink: true
                      }}
                      fullWidth
                    >
                      {taxTypes
                        .filter(group => {
                          return group.id !== 'DONATION';
                        })
                        .map(group => {
                          return (
                            <MenuItem key={group.id} value={group.id}>
                              {group.name}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </div>
                  {usageType === USAGE_TYPE_MENU && (
                    <>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            id="reducedTax"
                            checked={reducedTaxCheck}
                          />
                        }
                        label="軽減税率対象"
                        onChange={e => {
                          setReducedTaxCheck(e.target.checked);
                          convertReducedTax(e.target.checked);
                          calcPrice(e);
                        }}
                      />
                      <div style={{ fontSize: 14 }}>
                        価格の消費税の設定をお願いします。
                        <br />
                        ・外税
                        <br />
                        ・内税
                        <br />
                        ※テイクアウトの場合は、「軽減税率対象」にチェックを入れてください。
                      </div>
                    </>
                  )}
                </TableCell>
              </TableRow>
              {usageType === USAGE_TYPE_COMBO && (
                <>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        id="quantityPromotion"
                        name="quantityPromotion"
                        select
                        isClearable
                        label="付与無料枚数"
                        className={classes.textField}
                        margin="normal"
                        value={quantityPromotion}
                        InputProps={{
                          shrink: true
                        }}
                        onChange={e => {
                          setQuantityPromotion(e.target.value);
                        }}
                        onBlur={validQuantityPromotion}
                        style={{ marginTop: 0 }}
                      >
                        {quantityReleaseList.map(item => {
                          return (
                            <MenuItem key={item.value} value={item.value}>
                              {item.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                      <ValidationText message={errors.quantityPromotionError} />
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.tableCellBorderNone, classes.colLeft]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colRight
                      ]}
                    >
                      <TextField
                        label="おまけ"
                        className={classes.textFieldLong}
                        margin="normal"
                        onChange={e => {
                          setPromotionDescription(e.target.value);
                        }}
                        inputProps={{
                          maxLength: 1000
                        }}
                        value={promotionDescription}
                        style={{ marginTop: 0 }}
                      />
                    </TableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <RequiredButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    required
                    select
                    label="ジャンル"
                    className={classes.textField}
                    margin="normal"
                    value={menuGenreId}
                    onChange={e => {
                      setMenuGenreId(e.target.value);
                    }}
                    InputLabelProps={{
                      shrink: true
                    }}
                    onBlur={validMenuGenre}
                    style={{ width: '100%' }}
                  >
                    {menuGenre &&
                      menuGenre.map(item => {
                        return (
                          <MenuItem
                            key={item.menuGenreId}
                            value={item.menuGenreId}
                          >
                            {item.menuGenreName}
                          </MenuItem>
                        );
                      })}
                  </TextField>
                  <ValidationText message={errors.menuGenreError} />
                </TableCell>
              </TableRow>
              {usageType === USAGE_TYPE_MENU && (
                <TableRow>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colLeft]}
                  >
                    <AnyButton />
                  </TableCell>
                  <TableCell
                    className={[classes.tableCellBorderNone, classes.colRight]}
                  >
                    <TextField
                      label="説明"
                      multiline
                      rows="4"
                      defaultValue={description}
                      className={classes.textFieldLong}
                      onChange={e => {
                        setDescription(e.target.value);
                      }}
                      fullWidth
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        maxLength: 1000
                      }}
                      value={description}
                    />
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colLeft]}
                >
                  <AnyButton />
                </TableCell>
                <TableCell
                  className={[classes.tableCellBorderNone, classes.colRight]}
                >
                  <TextField
                    label="タグ"
                    value={tagStr}
                    className={classes.textFieldLong}
                    onChange={e => {
                      setTagStr(e.target.value);
                      splitTagStr(e.target.value);
                    }}
                    fullWidth
                    InputLabelProps={{
                      shrink: true
                    }}
                  />
                  <div className={classes.marginTop}>
                    #おすすめ #おふくろの味 #学生に ＃ガッツリ
                    などメニューの特徴を表すタグを記載できます。
                  </div>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <div className={classes.advancedSettingNote}>
            <div
              className={classes.displayFlexHelp}
              onClick={() => updateOpenAdvancedSetting(!openAdvancedSetting)}
              aria-hidden="true"
              style={{ cursor: 'pointer', alignItems: 'flex-start' }}
            >
              <div
                style={{
                  fontSize: 20,
                  fontWeight: 700
                }}
                className={classes.divHelp}
              >
                高度な設定
              </div>
              {openAdvancedSetting ? (
                <KeyboardArrowUp />
              ) : (
                <KeyboardArrowDown />
              )}
            </div>
            <div style={{ marginTop: 8, fontSize: 16 }}>
              以下の高度な設定は必須ではありません。詳細設定を希望される場合のみご利用ください。高度な設定により、ご利用条件・ご利用期間などが異なります。項目の詳細を十分にご理解いただいたうえで、設定をお願いいたします。
            </div>
          </div>
          {openAdvancedSetting && (
            <>
              <Table className={classes.editTable}>
                <TableBody>
                  {usageType !== USAGE_TYPE_MENU && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <RequiredButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            required
                            label="メニュー名"
                            defaultValue={menuName}
                            className={classes.textField}
                            onChange={e => {
                              setMenuName(e.target.value);
                            }}
                            onBlur={validMenuName}
                            fullWidth
                            InputLabelProps={{
                              shrink: true
                            }}
                            value={menuName}
                            inputProps={{
                              maxLength: 250
                            }}
                          />
                          <ValidationText message={errors.menuNameError} />
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <RequiredButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <FormLabel className={classes.description}>
                            メニュー画像
                          </FormLabel>

                          {!isImageDefault && (
                            <div>
                              <Button
                                variant="outlined"
                                color="primary"
                                component="span"
                                className={classes.button}
                                onClick={() => renderImageDefault(price, true)}
                                disabled={price === ''}
                              >
                                デフォルト画像を選択
                              </Button>
                            </div>
                          )}
                          <FileUpload
                            label="image"
                            file={image}
                            setFile={setImage}
                            previewImage={previewImage}
                            setPreviewImage={handleAddImage}
                            isOnlyImage
                          />
                          <ValidationText message={errors.imageError} />
                          <div className={classes.textExplain}>
                            ※8MB以内でお願いします。
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                        >
                          <TextField
                            label="説明"
                            multiline
                            rows="4"
                            defaultValue={description}
                            className={classes.textFieldLong}
                            onChange={e => {
                              setDescription(e.target.value);
                            }}
                            fullWidth
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              maxLength: 1000
                            }}
                            value={description}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                  {usageType === USAGE_TYPE_COMBO && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone,
                            classes.colLeft
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone,
                            classes.colRight
                          ]}
                        >
                          <Typography
                            component="div"
                            className={classNames(
                              classes.labelText,
                              classes.labelControl,
                              classes.description
                            )}
                          >
                            利用制限
                          </Typography>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft
                          ]}
                          style={{ paddingTop: 8 }}
                        />
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colRight
                          ]}
                          style={{ paddingTop: 8 }}
                        >
                          <div>
                            <RadioGroup
                              row
                              value={usageLimit}
                              onChange={e => {
                                setUsageLimit(parseInt(e.target.value, 10));
                              }}
                            >
                              <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="なし"
                              />
                              <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="1日1枚"
                              />
                            </RadioGroup>
                          </div>
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                  <TableRow>
                    <TableCell
                      className={[
                        classes.tableCellBorderNone,
                        classes.colLeft,
                        classes.paddingBottomNone
                      ]}
                    >
                      <AnyButton />
                    </TableCell>
                    <TableCell
                      className={classNames(
                        classes.colRight,
                        classes.positionRelative,
                        classes.tableCellBorderNone,
                        classes.paddingBottomNone
                      )}
                    >
                      <div className={classes.displayFlexHelp}>
                        <div className={classes.divHelp}>
                          <Typography style={{ fontSize: 14 }}>
                            利用期間
                          </Typography>
                        </div>
                        <HelpIcon
                          className={classes.iconHelpEx}
                          onClick={handleShowHelpExpiration}
                        />
                        {helpExpiration && (
                          <div ref={ref} className={classes.divExplanation}>
                            <Card>
                              <CloseIcon
                                className={classes.helpCloseBtn}
                                onClick={handleCloseHelpPopup}
                              />
                              <CardContent
                                className={classes.textHelpExplainDiv}
                              >
                                <Typography className={classes.textHelpExplain}>
                                  【指定しない】
                                  <br />
                                  購入日から180日間ご利用いただけます。
                                  <br />
                                  <br />
                                  【期限指定】
                                  <br />
                                  利用できる期限日を日付で指定して設定できます。
                                  <br />
                                  例）〜3月31日まで→購入日に関わらず3月31日まで利用可能
                                  <br />
                                  <br />
                                  【期間指定】
                                  <br />
                                  チケットを購入してから利用できる期間を日数で指定して設定できます。
                                  <br />
                                  例）30日間利用可能→購入日が1月1日の場合、1月31日まで利用可能
                                  <br />
                                  ※チケットの利用期間は最長で購入日から180日間です。
                                </Typography>
                              </CardContent>
                            </Card>
                          </div>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell
                      className={[classes.paddingBottomNone, classes.colLeft]}
                      style={{ paddingTop: 8 }}
                    />
                    <TableCell
                      className={[classes.paddingBottomNone, classes.colRight]}
                      style={{ paddingTop: 8 }}
                    >
                      <RadioGroup
                        row
                        value={expirationType}
                        onChange={e => {
                          setExpirationType(parseInt(e.target.value, 10));
                          resetExpirationValue();
                        }}
                      >
                        <FormControlLabel
                          value={2}
                          control={<Radio color="primary" />}
                          label="指定しない"
                        />
                        <FormControlLabel
                          value={1}
                          control={<Radio color="primary" />}
                          label="期限指定"
                        />
                        <FormControlLabel
                          value={0}
                          control={<Radio color="primary" />}
                          label="期間指定"
                        />
                      </RadioGroup>
                      {expirationType === 0 && (
                        <TextField
                          id="expiration"
                          name="expiration"
                          select
                          label="利用期間"
                          className={classes.textField}
                          margin="normal"
                          value={expiration}
                          InputProps={{
                            shrink: 'true'
                          }}
                          onChange={e => {
                            setExpiration(e.target.value);
                          }}
                          // variant="filled"
                        >
                          {expirationList.map(item => {
                            return (
                              <MenuItem key={item.value} value={item.value}>
                                {item.label}
                              </MenuItem>
                            );
                          })}
                        </TextField>
                      )}
                      {expirationType === 1 && (
                        <TextField
                          label="終了"
                          type="date"
                          className={classes.textField}
                          margin="normal"
                          InputLabelProps={{
                            shrink: true
                          }}
                          value={expirationEndDate}
                          inputProps={{
                            min: minExpirationDate,
                            max: maxExpirationDate
                          }}
                          onChange={e => {
                            setExpirationEndDate(e.target.value);
                          }}
                        />
                      )}
                    </TableCell>
                  </TableRow>
                  {usageType === USAGE_TYPE_VOUCHER && (
                    <TableRow>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colLeft
                        ]}
                        style={{ paddingTop: 32 }}
                      >
                        <AnyButton />
                      </TableCell>
                      <TableCell
                        className={[
                          classes.tableCellBorderNone,
                          classes.colRight
                        ]}
                        style={{ paddingTop: 32 }}
                      >
                        <Typography
                          component="div"
                          className={classNames(
                            classes.labelText,
                            classes.labelControl
                          )}
                          style={{ fontSize: 14 }}
                        >
                          利用方法
                        </Typography>
                        <div style={{ maxWidth: 706 }}>
                          <RadioGroup
                            row
                            value={menuLimitTotal}
                            onChange={e => {
                              setMenuLimitTotal(parseInt(e.target.value, 10));
                            }}
                            style={{ flexWrap: 'nowrap' }}
                          >
                            <div>
                              <FormControlLabel
                                value={1}
                                control={<Radio color="primary" />}
                                label="一円単位利用"
                              />
                              <div className={classes.noteText}>
                                残高が無くなるまで、一円単位で任意の金額を指定してご利用いただけます。
                              </div>
                            </div>
                            <div style={{ marginLeft: 24, marginRight: 82 }}>
                              <FormControlLabel
                                value={0}
                                control={<Radio color="primary" />}
                                label="一枚単位利用"
                              />
                              <div className={classes.noteText}>
                                額面が決まっているチケットを一枚ずつご利用いただけます。お釣りは出ません。
                              </div>
                            </div>
                          </RadioGroup>
                        </div>
                      </TableCell>
                    </TableRow>
                  )}
                  {usageType !== USAGE_TYPE_COMBO && (
                    <>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.tableCellBorderNone,
                            classes.colLeft,
                            classes.paddingBottomNone
                          ]}
                        >
                          <AnyButton />
                        </TableCell>
                        <TableCell
                          className={classNames(
                            classes.colRight,
                            classes.positionRelative,
                            classes.tableCellBorderNone,
                            classes.paddingBottomNone
                          )}
                        >
                          <div className={classes.displayFlexHelp}>
                            <div className={classes.divHelp}>
                              <Typography className={classes.description} />
                            </div>
                            <HelpIcon
                              className={classes.iconHelpEx}
                              onClick={handleShowHelpDonation}
                            />
                            {helpDonation && (
                              <div ref={ref} className={classes.divExplanation}>
                                <Card>
                                  <CloseIcon
                                    className={classes.helpCloseBtn}
                                    onClick={handleCloseHelpPopup}
                                  />
                                  <CardContent
                                    className={classes.textHelpExplainDiv}
                                  >
                                    <Typography
                                      className={classes.textHelpExplain}
                                      style={{ margin: '20px 0 0' }}
                                    >
                                      設定すると自動的に「誰でもごち」になり、税率が0％になります。
                                      <br />
                                      誰でもごちとは？
                                      <br />
                                      自分用やギフト用に購入するのではなく、「お店に寄付」してお店を訪れた不特定の相手にご利用いただく「ごち（チケット）」です。
                                      <br />
                                      詳細はマニュアルをご確認ください。
                                      <br />
                                      {`マニュアル： `}
                                      <Link
                                        href="https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/"
                                        target="_blank"
                                        color="primary"
                                      >
                                        https://shop-guide.gochimeshi.com/individual/daredemogochi-operation-manual/
                                      </Link>
                                      <br />
                                      ※チケットのご利用には、ユーザー登録が必要です。
                                      <br />
                                      ※店頭に専用QRコードをご用意いただき、ユーザー様のスマートフォンで読み取っていただく事でチケットを呼び出せます。
                                    </Typography>
                                  </CardContent>
                                </Card>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          className={[
                            classes.paddingBottomNone,
                            classes.colLeft
                          ]}
                        />
                        <TableCell
                          className={[
                            classes.paddingBottomNone,
                            classes.colRight
                          ]}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox id="isDonation" color="primary" />
                            }
                            label="寄付設定"
                            checked={taxType === 'DONATION'}
                            onChange={e => {
                              if (e.target.checked) {
                                setTaxType('DONATION');
                              } else {
                                setTaxType('INTERNAL');
                              }
                              calcPrice(e);
                            }}
                            disabled={shopGochiRestriction === 'MENTION_ONLY'}
                          />
                        </TableCell>
                      </TableRow>
                    </>
                  )}
                </TableBody>
              </Table>
              <div className={classes.qaBox} style={{ maxWidth: 343 }}>
                <div
                  className={classes.displayFlex}
                  style={{ alignItems: 'flex-start' }}
                >
                  <div className={classes.divHelp}>
                    <span className={classes.headerNoteDonation}>Q.</span>
                    <span className={classes.questionTextDonation}>
                      金額を非表示にするには？
                    </span>
                  </div>
                  {showQADonation ? (
                    <RemoveCircleOutline
                      color="primary"
                      onClick={() => setShowQADonation(false)}
                      style={{ cursor: 'pointer' }}
                    />
                  ) : (
                    <AddCircleOutline
                      color="primary"
                      onClick={() => setShowQADonation(true)}
                      style={{ cursor: 'pointer' }}
                    />
                  )}
                </div>
                {showQADonation && (
                  <div className={classes.answerNoteDonation}>
                    <div className={classes.headerNoteDonation}>A.</div>
                    <div className={classes.answerTextDonation}>
                      <div>
                        ギフト券の場合、金額を非表示にすることが可能です。
                        <br />
                        ご要望がある場合はお問い合わせください。
                      </div>
                      <div style={{ marginTop: 8 }}>お問い合わせフォーム</div>
                      <div>
                        <Link
                          href="https://support.gigi.tokyo/contact/contact01/"
                          target="_blank"
                          color="primary"
                        >
                          https://support.gigi.tokyo/contact/contact01/
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          <div className={classes.buttonsContainer}>
            <CancelButton onClickAction={cancelAction} color="primary" />
            <ConfirmButton onClickAction={confirmAction} />
          </div>
        </div>

        <Modal open={openMenuImageSamplePopup} className={classes.modal}>
          <MenuImageSampleGroupDialog
            handleClose={() => updateOpenMenuImageSamplePopup(false)}
            menuImageSampleList={menuImageSampleList}
            setPreviewImage={setPreviewImage}
            setIsImageDefault={setIsImageDefault}
            setImageError={setImageError}
          />
        </Modal>

        <Modal open={openAddConfirm} className={classes.modal}>
          <GochiMenuAddConfirmGroupV2
            backAction={backAction}
            registerAction={registerAction}
            addConfirm={multiLangData}
            reducedTaxMenuPrefix={reducedTaxMenuPrefix}
            groups={groups}
            shopName={shopName}
            menuGenreName={menuGenreName}
            previewImage={previewImage}
            getUsageTypeName={getUsageTypeName}
            getMenuChildTypeName={getMenuChildTypeName}
          />
        </Modal>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
